import React from "react";
import "../ConfigurePayout.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const MapToChargeComponent = (props) => {
  return (
    <div className="fs-charges-container">
      <div className="fs-charges-column">
        {props.createFranchiseeCharges?.slice().reverse().map((charge, index) => (
          <Card key={charge.id} className="fs-charge-card">
            <div className="fs-charge-header">
              <Typography className="fs-charge-title">
                Charge {index + 1}: {charge.name}
              </Typography>
              <input
                className="fs-charge-checkbox"
                type="checkbox"
                checked={props.selectedChargeIds.includes(charge.id)}
                onChange={() => props.handleCheckboxChange(charge.id)}
              />
            </div>
            
            <CardContent className="fs-charge-body">
              <ul className="fs-charge-list">
                <li className="fs-charge-item"><strong>ID:</strong> {charge.id}</li>
                <li className="fs-charge-item"><strong>Description:</strong> {charge.description}</li>
                <li className="fs-charge-item"><strong>Type:</strong> {charge.chargeType}</li>
                <li className="fs-charge-item"><strong>Value Type:</strong> {charge.valueType}</li>
                <li className="fs-charge-item"><strong>Value:</strong> {charge.value}</li>
                {charge.valueMin && (
                  <li className="fs-charge-item"><strong>Min Value:</strong> {charge.valueMin}</li>
                )}
                {charge.valueMax && (
                  <li className="fs-charge-item"><strong>Max Value:</strong> {charge.valueMax}</li>
                )}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MapToChargeComponent;